/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationEffectDateMutation from '../graphql/mutations/SaveSimulationEffectDateMutation.js';

export const useSaveSimulationEffectDateMutation = () => {
  return useCommitMutation(SaveSimulationEffectDateMutation, {
    dataProp: 'saveSimulationEffectDate_M_simulation_effect_date'
  });
};

export default useSaveSimulationEffectDateMutation;
